import React, { useEffect } from "react";
import CommonDoctorCard from "../../../common-components/common_doctor_card/CommonDoctorCard";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import "./Doctors.css"
import {
  getAllDoctors,
  setDoctorFilter,
} from "../../../../features/doctor/doctorSlice";
export default function Doctors() {
  const { control } = useForm();

  const filters = useSelector((state) => state.doctor.filters);

  const options = [
    { value: "az", label: "Name: Ascending " },
    { value: "za", label: "Name: Descending  " },
    { value: "low_to_high", label: "Price: Low to High" },
    { value: "high_to_low", label: "Price: High to Low" },
    { value: "new_to_old", label: "Newest First" },
    { value: "old_to_new", label: "Old First" },
  ];
  const dispatch = useDispatch();

  const handleResetFilters = () => {
    dispatch(
      setDoctorFilter({
        specialization_id: [],
        rating_ids: [],
        gender_ids: [],
        min_price: filters?.fees_min ?? 0,
        max_price: filters?.fees_max ?? 0,
        sortBy: "",
      }),
    );
  };

  const allDoctors = useSelector((state) => state.doctor.allDoctors);

  useEffect(() => {
    dispatch(
      getAllDoctors({
        category_id: filters?.category_id || "",
        specialization_id: JSON.stringify(filters?.specialization_id || []),
        gender_ids: JSON.stringify(filters?.gender_ids || []) || "",
        rating_ids: JSON.stringify(filters?.rating_ids || []) || "",
        name: filters?.name || "",
        sortBy: filters?.sortBy || "",
        minprice: filters.min_price,
        maxprice: filters.max_price,
      }),
    );
  }, [dispatch, filters]);
  return (
    <div className="doctor_wrapper">
      {" "}
      <div className="common_title_sort_holder">
        <p className="title_text">All Doctors</p>

        {/* <div className="right_div">
          <p className="sort_text">Sort By:</p>

          <div className="sort_select">
            <Controller
              name="sort_by"
              control={control}
              defaultValue="relevance"
              render={({ field }) => (
                <Select
                  {...field}
                  options={options}
                  placeholder="Sort By"
                  value={options.find((option) => option.value === field.value)}
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption.value);

                    dispatch(
                      setDoctorFilter({
                        sortBy: selectedOption.value,
                      }),
                    );
                  }}
                />
              )}
            />
          </div>
        </div> */}
        <div className="right_div">
  <p className="sort_text">Sort By:</p>

  <div className="sort_select">
    <Controller
      name="sort_by"
      control={control}
      defaultValue="relevance"
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          placeholder="Sort By"
          classNamePrefix="sort-select"
          value={
            options.find((option) => option.value === filters?.sortBy) || null
          }
          onChange={(selectedOption) => {
            field.onChange(selectedOption.value);

            dispatch(
              setDoctorFilter({
                sortBy: selectedOption.value,
              })
            );
          }}
        />
      )}
    />
  </div>
  <button
    type="button"
    className="reset_filter_btn"
    onClick={handleResetFilters}
  >
    Reset
  </button>
</div>
      </div>
      {/* <div className="row d-flex">
        <div className="col-md-12 col-6">
          {" "}
          {doctorsData.map((doctor) => (
            <CommonDoctorCard
              key={doctor.id}
              image={doctor.image}
              specialist={doctor.specialist}
              name={doctor.name}
              hospital={doctor.hospital}
              rating={doctor.rating}
              reviews={doctor.reviews}
              price={doctor.price}
            />
          ))}
        </div>
      </div> */}
      <div className="row">
        {allDoctors?.data?.length > 0 ? (
          allDoctors?.data?.map((doctor, index) => (
            <div
              className={`col-md-12 col-6 mb-3 
      ${index % 2 === 0 ? "pe-0 px-md-2" : "ps-0 px-md-2"}`}
              key={doctor.id}
            >
              <CommonDoctorCard
                doctor={doctor}
                image={process.env.REACT_APP_IMG_URL + doctor?.image}
                specialist={doctor.Doctor_Detail?.Specialization?.name || ""}
                id={doctor.id}
                name={`${doctor?.Doctor_Detail?.doctor_code ||
                  ""} ${doctor?.name || ""}`}
                hospital={doctor.Doctor_Detail?.hospital_name || ""}
                average_rating={doctor.average_rating || "0"}
                reviews={doctor.reviews}
                price={doctor.Doctor_Detail?.fees || ""}
              />
            </div>
          ))
        ) : (
          <div className="col-12 text-center py-4">No doctors found.</div>
        )}
      </div>
    </div>
  );
}
